import { useMemo } from 'react';

import moment from 'moment';

import useCurrency from '@/hooks/query/useCurrency';
import useGasPrice from '@/hooks/query/useGasPrice';
import { USDDollarFormatter } from '@/utils/formatter';

import EthIcon from '../../assets/icons/icon-eth.svg';
import GasIcon from '../../assets/icons/icon-gas.svg';
import ShieldIcon from '../../assets/icons/icon-shield.svg';

const auditDays = moment().diff(moment('2024-11-24'), 'days');

const LiveEthGasInfoBox = () => {
  const { data: ethData } = useCurrency();
  const { data: gasData } = useGasPrice();
  const ethValue = ethData?.[0].quote.USD.price || 0;

  const gasValue = gasData?.proposeGasPrice || 0;

  const boxInfo = useMemo(() => {
    return [
      {
        id: 0,
        Icon: EthIcon,
        value: USDDollarFormatter(Number(ethValue), 'USD'),
      },
      {
        id: 1,
        Icon: GasIcon,
        value: Number(Number(gasValue).toFixed(3)),
      },
      {
        id: 2,
        Icon: ShieldIcon,
        value: (
          <>
            <span>Running SAFE for {auditDays} days.</span>{' '}
            <a className='!text-primary dark:!text-primary-blue-100 underline' target='_blank' href='https://github.com/ResonanceCybersecurity/audits/blob/main/Solidity%20Smart%20Contract%20Audits/Audit_Report_NTYW-LEN_FINAL_22.pdf'>
              Audit report
            </a>
          </>
        ),
      },
    ];
  }, [ethValue, gasValue]);

  return (
    <div className='py-2 px-[18px] flex justify-between rounded bg-white-100 dark:!bg-coal w-max min-w-52 gap-7'>
      {boxInfo.map(({ Icon, value, id }) => {
        return (
          <div key={id} className='flex items-center gap-[6px] [&_path]:fill-coal-250 dark:[&_path]:fill-white'>
            <Icon />
            <p className='text-xs font-normal'>{value}</p>
          </div>
        );
      })}
    </div>
  );
};

export default LiveEthGasInfoBox;
